import {
  addDays,
  addMilliseconds,
  endOfMonth,
  getDay,
  startOfMonth
} from "date-fns";
import { range, sample } from "lodash";
import { TimesheetEntry } from "../core/types";
import uid from "short-uuid";

/**
 * Creates sample data for the given date range.
 * @param dateRange optional - without a dateRange only data for the current month will be generated
 */
export function createSampleData(dateRange?: [Date, Date]) {
  const [from, to] = dateRange
    ? dateRange
    : [startOfMonth(new Date()), endOfMonth(new Date())];

  const result: TimesheetEntry[] = [];

  for (const entry of generateSampleData(from)) {
    result.push({ id: uid.generate(), ...entry });
    if (entry.start.getTime() > to.getTime()) {
      break;
    }
  }

  return result;
}

/**
 * Sampledata generator
 * @param from
 */
export function* generateSampleData(from: Date) {
  const workingDays = [1, 2, 3, 4, 5];
  const chanceForNonWorkingDays = 0.1;
  const averageStart = 8 * 1000 * 60 * 60; // 08:00
  const averageEnd = averageStart * 2; // 16:00

  const maxEntriesPerDay = 4;

  for (
    let date = from;
    date.getTime() < new Date(2050, 1, 1).getTime();
    date = addDays(date, 1)
  ) {
    if (!workingDays.includes(getDay(date))) {
      continue;
    }

    const isNonWorkingDay = Math.random() < chanceForNonWorkingDays;

    if (isNonWorkingDay) {
      yield {
        start: date,
        duration: 0,
        description: "Vacation"
      };
      continue;
    }

    yield* generateWorkday(date, {
      averageStart,
      averageEnd,
      maxEntriesPerDay
    });
  }
}

function* generateWorkday(
  date: Date,
  options: {
    averageStart: number;
    averageEnd: number;
    maxEntriesPerDay: number;
  }
) {
  const { averageStart, averageEnd, maxEntriesPerDay } = options;

  const numEntries = sample(range(1, maxEntriesPerDay))!;
  const averageDuration = (averageEnd - averageStart) / numEntries;

  let time = Math.floor(
    averageStart + 3600000 * Math.random() * (Math.random() > 0.5 ? 1 : -1)
  );

  for (let i = 0; i < numEntries; i++) {
    const variance = Math.random() + (Math.random() > 0.5 ? 0.5 : -0.5);

    const duration = Math.floor(averageDuration * variance);

    yield {
      start: addMilliseconds(date, time),
      duration
    };

    time += duration;
  }
}
